var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchedes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2597_2602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2597_2602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.76 11.0001C21.76 16.9469 16.9475 21.7594 11.0006 21.7594C5.05371 21.7594 0.241211 16.9469 0.241211 11.0001C0.241211 5.05319 5.05371 0.240692 11.0006 0.240692C16.9475 0.240692 21.76 5.05319 21.76 11.0001ZM11.0006 0.893817C5.39746 0.893817 0.894336 5.39694 0.894336 11.0001C0.894336 16.6032 5.43184 21.1063 11.0006 21.1063C16.6037 21.1063 21.1068 16.5688 21.1068 11.0001C21.1068 5.39694 16.6037 0.893817 11.0006 0.893817Z",
    fill: "url(#paint0_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 0.893784C5.39668 0.893784 0.893555 5.39691 0.893555 11C0.893555 16.6032 5.43105 21.1063 10.9998 21.1063C16.6029 21.1063 21.1061 16.5688 21.1061 11C21.1061 5.39691 16.6029 0.893784 10.9998 0.893784ZM10.9998 20.4532C5.7748 20.4532 1.54668 16.225 1.54668 11C1.54668 5.77503 5.7748 1.54691 10.9998 1.54691C16.2248 1.54691 20.4529 5.77503 20.4529 11C20.4529 16.225 16.2248 20.4532 10.9998 20.4532Z",
    fill: "url(#paint1_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11 21.7594C16.9469 21.7594 21.7594 16.9469 21.7594 11C21.7594 5.05313 16.9469 0.240625 11 0.240625C5.05313 0.240625 0.240625 5.05313 0.240625 11C0.240625 16.9469 5.05313 21.7594 11 21.7594ZM11 0C17.05 0 22 4.95 22 11C22 17.05 17.05 22 11 22C4.95 22 0 17.05 0 11C0 4.95 4.95 0 11 0Z",
    fill: "url(#paint2_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.756836 11.0344C0.756836 5.39694 5.32871 0.756317 11.0006 0.756317C16.6725 0.756317 21.2443 5.36257 21.2443 11.0344C21.2443 16.6719 16.6725 21.2438 11.0006 21.2438C5.32871 21.2438 0.756836 16.6719 0.756836 11.0344ZM3.95371 3.95319C2.13184 5.77507 0.997461 8.28444 0.997461 11.0344C0.997461 13.7844 2.13184 16.2938 3.91934 18.0813C5.74121 19.8688 8.25059 21.0032 11.0006 21.0032C13.7506 21.0032 16.26 19.9032 18.0475 18.0813C19.8693 16.2938 20.9693 13.7844 20.9693 11.0344C20.9693 8.28444 19.835 5.77507 18.0475 3.95319C16.26 2.13132 13.7506 0.996942 11.0006 0.996942C8.25059 0.996942 5.74121 2.13132 3.95371 3.95319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.0002 20.4875C8.45645 20.4875 6.08457 19.4906 4.29707 17.7031C2.50957 15.9156 1.5127 13.5437 1.5127 11C1.5127 8.45622 2.50957 6.08434 4.29707 4.29684C6.08457 2.50934 8.45645 1.51247 11.0002 1.51247C13.5439 1.51247 15.9158 2.50934 17.7033 4.29684C19.4908 6.08434 20.4877 8.45622 20.4877 11C20.4877 13.5437 19.4908 15.9156 17.7033 17.7031C15.9158 19.4906 13.5439 20.4875 11.0002 20.4875ZM11.0002 20.2125C13.4408 20.2125 15.7783 19.25 17.4971 17.5312C19.2502 15.7781 20.1783 13.475 20.1783 11.0343C20.1783 8.59372 19.2158 6.25622 17.4971 4.53747C15.7439 2.78434 13.4408 1.85622 11.0002 1.85622C8.55957 1.85622 6.22207 2.81872 4.50332 4.53747C2.7502 6.22184 1.7877 8.55934 1.7877 11C1.7877 13.4406 2.7502 15.7781 4.46895 17.4968C6.22207 19.25 8.55957 20.2125 11.0002 20.2125Z",
    fill: "url(#paint3_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3525 15.4688C19.1807 15.3313 12.5463 10.0719 12.5463 10.0719L10.9994 1.23753C10.8963 1.27191 10.7588 1.37503 10.69 1.51253L9.59004 10.1063L2.74941 15.3657C2.74941 15.3657 2.61191 15.5375 2.54316 15.6407C2.50879 15.7094 2.50879 15.8125 2.50879 15.9157L10.965 12.4438L19.4213 15.9157C19.49 15.7438 19.4213 15.5719 19.3525 15.4688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0688 11.2751L11 12.8563L18.7688 15.9844C19.0437 16.1219 19.25 16.0532 19.4563 15.9157L11.1719 11.2407C11.1375 11.2063 11.0688 11.2407 11.0688 11.2751Z",
    fill: "#565F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0693 11.2751C11.0693 11.2751 11.5162 12.0657 12.0318 12.6157C12.7537 13.4063 13.7162 13.9563 13.7162 13.9563L18.7693 15.9844C19.0443 16.1219 19.2506 16.0532 19.4568 15.9157L11.1725 11.2407C11.1381 11.2063 11.0693 11.2407 11.0693 11.2751Z",
    fill: "url(#paint4_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4221 15.6062C19.4221 15.5718 19.3877 15.5375 19.3533 15.4687L12.2721 10.2781L11.3096 10.8968C11.3096 10.8968 11.3783 10.9312 11.4127 10.8968C11.5158 10.8625 11.7221 10.8281 11.9283 10.8968C12.1002 10.9656 19.4221 15.6406 19.4221 15.6062C19.4221 15.6406 19.4221 15.6406 19.4221 15.6062Z",
    fill: "#A4AAAE",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1818 15.2968L12.5818 10.0718L12.2725 10.2781L19.3537 15.5031C19.3193 15.4343 19.2506 15.3656 19.1818 15.2968Z",
    fill: "#333E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1721 10.7594L11.1377 10.7938C11.1377 10.7938 11.1377 10.8626 11.2064 10.8282C11.2408 10.7938 12.2377 10.2782 12.5814 10.0719L11.3783 1.82194C11.3439 1.51257 11.2064 1.37507 10.9658 1.27194L11.1033 10.8282L11.1721 10.7594Z",
    fill: "#565F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5877 1.82194V2.26882L9.83144 9.86569C9.83144 9.96882 9.86582 10.0719 9.96895 10.1407L10.4158 10.4844L10.7252 2.09694L10.7596 1.44382C10.6564 1.51257 10.6221 1.65007 10.5877 1.82194ZM10.1752 10.6219L9.76269 10.2782L2.78457 15.3313C2.78457 15.3313 2.57832 15.4688 2.54395 15.6063L2.78457 15.4688L10.1064 10.8626C10.2439 10.7938 10.2783 10.7251 10.1752 10.6219Z",
    fill: "#A4AAAE",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8963 11.2751C10.8963 11.2407 10.8619 11.2063 10.8275 11.2407L2.50879 15.9501C2.71504 16.0876 2.92129 16.1219 3.19629 16.0188L10.965 12.8907L10.8963 11.2751Z",
    fill: "#565F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1377 10.7937C11.1377 10.7937 11.1377 10.8281 11.1721 10.8281H11.2064C11.2408 10.7937 12.2377 10.2781 12.5814 10.0718L12.4439 9.07497L11.3783 1.82184C11.3783 1.68434 11.3439 1.58122 11.2752 1.51247C11.2752 1.51247 11.7908 8.45622 11.7908 9.21247C11.7908 10.2093 11.1377 10.7937 11.1377 10.7937Z",
    fill: "url(#paint5_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8963 11.2751C10.8963 11.2407 10.8619 11.2063 10.8275 11.2407L2.50879 15.9501C2.71504 16.0876 2.92129 16.1219 3.19629 16.0188L10.965 12.8907L10.8963 11.2751Z",
    fill: "url(#paint6_linear_2597_2602)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M3.19746 15.9844L10.9662 12.8563L10.8975 11.3438C10.76 11.7563 10.5193 12.2031 9.86621 12.5469C9.38496 12.8219 4.77871 15.0906 3.12871 15.8813C3.02559 15.95 2.88809 15.9844 2.81934 16.0187C2.95684 16.0875 3.05996 16.0531 3.19746 15.9844Z",
    fill: "url(#paint7_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1721 10.7594L11.1377 10.7938C11.1377 10.7938 11.1377 10.8626 11.2064 10.8282C11.2408 10.7938 12.2377 10.2782 12.5814 10.0719L11.3783 1.82194C11.3439 1.51257 11.2064 1.37507 10.9658 1.27194L11.1033 10.8282L11.1721 10.7594Z",
    fill: "url(#paint8_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1721 10.7594L11.1377 10.7938C11.1377 10.7938 11.1377 10.8626 11.2064 10.8282C11.2408 10.7938 12.2377 10.2782 12.5814 10.0719L11.3783 1.82194C11.3439 1.51257 11.2064 1.37507 10.9658 1.27194L11.1033 10.8282L11.1721 10.7594Z",
    fill: "url(#paint9_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75371 15.2625C1.51309 14.7125 0.138086 12.0313 1.65059 6.875H1.06621C0.756836 7.90625 0.516211 8.525 0.378711 9.45313C0.378711 9.45313 0.309961 9.79688 0.275586 10.175C0.241211 10.5531 0.241211 10.7594 0.241211 11C0.241211 13.0625 0.756836 14.2656 0.756836 14.2656C1.30684 15.9844 2.26934 17.5313 3.57559 18.7C4.70996 19.6969 6.46309 20.4531 7.90684 20.7281C7.66621 20.6938 3.54121 18.9406 1.75371 15.2625Z",
    fill: "url(#paint10_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1375 11.2063H10.8281C10.8625 11.2063 10.8969 11.2063 10.8969 11.2406L10.9656 12.8219H11L11.0688 11.2406C11.0688 11.2063 11.1031 11.1719 11.1375 11.2063Z",
    fill: "url(#paint11_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 0.790558C18.0469 2.16556 21.45 5.94681 21.45 10.7249C21.45 16.4999 16.8438 21.2093 11 21.2093V21.7593C16.8438 21.7593 21.7594 16.9468 21.7594 10.9999C21.7594 6.25618 18.7344 2.26868 14.4375 0.790558Z",
    fill: "url(#paint12_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2125 6.94378C17.8063 1.40941 12.375 1.10003 12.0656 1.06566H12.0312C16.1906 1.82191 18.8375 4.53753 19.7656 7.39066V7.42503C20.1781 8.52503 20.3844 9.69378 20.4188 10.9657C20.4531 12.1688 20.1781 13.5094 19.6625 14.7469C19.6281 14.9188 19.5938 15.125 19.5594 15.125H20.1094C21.7594 12.0313 21.0375 8.90316 20.2125 6.94378Z",
    fill: "url(#paint13_linear_2597_2602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.756836 11.0344C0.756836 5.39694 5.32871 0.756317 11.0006 0.756317C16.6725 0.756317 21.2443 5.36257 21.2443 11.0344C21.2443 16.6719 16.6725 21.2438 11.0006 21.2438C5.32871 21.2438 0.756836 16.6719 0.756836 11.0344ZM3.95371 3.95319C2.13184 5.77507 0.997461 8.28444 0.997461 11.0344C0.997461 13.7844 2.13184 16.2938 3.91934 18.0813C5.74121 19.8688 8.25059 21.0032 11.0006 21.0032C13.7506 21.0032 16.26 19.9032 18.0475 18.0813C19.8693 16.2938 20.9693 13.7844 20.9693 11.0344C20.9693 8.28444 19.835 5.77507 18.0475 3.95319C16.26 2.13132 13.7506 0.996942 11.0006 0.996942C8.25059 0.996942 5.74121 2.13132 3.95371 3.95319Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71582 15.4L9.72832 10.3468C10.1064 10.5531 10.7252 10.8281 10.7939 10.8281C10.8627 10.8625 10.8627 10.7937 10.8627 10.7937L10.0033 10.0718C9.9002 10.0031 9.86582 9.89997 9.86582 9.79684L10.6908 1.51247C10.6564 1.54684 10.6564 1.61559 10.6221 1.64997C10.5877 1.71872 10.5877 1.75309 10.5877 1.82184L9.38457 10.1062L2.78457 15.2968C2.7502 15.3312 2.71582 15.3656 2.71582 15.4Z",
    fill: "#333F47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2597_2602",
    x1: 2.7499,
    y1: 4.09001,
    x2: 19.2513,
    y2: 17.9101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CDD0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A5ACAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#98A0A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#828A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#667075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#535C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#475158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#434D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475157"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2597_2602",
    x1: 3.25546,
    y1: 4.48906,
    x2: 18.7242,
    y2: 17.4828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81898D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B3B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEE0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2597_2602",
    x1: 14.7596,
    y1: 21.3342,
    x2: 7.23147,
    y2: 0.640751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1C5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9BA1A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D8487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#687074",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5B6469",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576065",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2597_2602",
    x1: 6.25679,
    y1: 2.78469,
    x2: 15.7436,
    y2: 19.2153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C1C5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9BA1A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D8487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#687074",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5B6469",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576065",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2597_2602",
    x1: 15.2933,
    y1: 13.5414,
    x2: 14.709,
    y2: 14.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27343C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00111E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2597_2602",
    x1: 13.6058,
    y1: 10.0072,
    x2: 12.6433,
    y2: 8.46034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#02131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#02131F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2597_2602",
    x1: 10.9932,
    y1: 12.4906,
    x2: 9.54948,
    y2: 12.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#02131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#02131F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2597_2602",
    x1: 7.14749,
    y1: 14.4045,
    x2: 6.94124,
    y2: 13.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#02131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02131F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2597_2602",
    x1: 12.2384,
    y1: 5.91738,
    x2: 11.0696,
    y2: 6.05488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#02131F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02131F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2597_2602",
    x1: 12.2748,
    y1: 5.89779,
    x2: 11.4839,
    y2: 6.00091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27343C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B474E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2597_2602",
    x1: -0.123164,
    y1: 11.2857,
    x2: 9.46746,
    y2: 16.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25323B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#27343C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2597_2602",
    x1: 10.9828,
    y1: 12.8563,
    x2: 10.9828,
    y2: 11.2063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A5ABAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ABAF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2597_2602",
    x1: 16.3797,
    y1: 0.790558,
    x2: 16.3797,
    y2: 21.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B7378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27343C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#333F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434D54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2597_2602",
    x1: 19.6931,
    y1: 2.782,
    x2: 15.0525,
    y2: 9.58825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#49545B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchedes);
export default __webpack_public_path__ + "static/media/merchedes.646a0841169e1d698b093a94b4e63539.svg";
export { ForwardRef as ReactComponent };